import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'BankCardNumber',
    itemProps: {
      label: '银行卡号',
      name: uuid,
    },
    BValue: '',
    outerAttr: {
      rules: [{ required: true }],
    },
    innerStyle: {
      width: '50%',
      minWidth: "300px"
    },
  }
};
